// extracted by mini-css-extract-plugin
module.exports = {"text--input--small":"text--input--small__d0Hxy","text--input--large":"text--input--large__2dezM"};